import Modal from 'components/Layout/Modal';
import ActionForm from '../ActionForm/ActionForm';

const ActionFormPopup = ({
  title = "Participant Request",
  initialValues,
  validationSchema,
  isRejecting,
  setIsRejecting,
  handleReject,
  handleApproveRequest,
  onHide,
  btnLoading
}) => {
  return (
    <Modal
      onHide={onHide}
      size="md"
      onClose={onHide}
      titleBesideClose={title}
      titleBesideCloseClassName="text-16-300-20 color-4141"
    >
      <div className="cp-20">
        <ActionForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          isRejecting={isRejecting}
          setIsRejecting={setIsRejecting}
          handleReject={handleReject}
          handleApproveRequest={handleApproveRequest}
          onHide={onHide}
          btnLoading={btnLoading}
        />
      </div>
    </Modal>
  );
};

export default ActionFormPopup;
